import { render, staticRenderFns } from "./orderRecordList.vue?vue&type=template&id=a9f4d6aa&scoped=true&"
import script from "./orderRecordList.vue?vue&type=script&lang=js&"
export * from "./orderRecordList.vue?vue&type=script&lang=js&"
import style0 from "./orderRecordList.vue?vue&type=style&index=0&id=a9f4d6aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f4d6aa",
  null
  
)

export default component.exports